import { useEffect, useState } from 'react';

interface ScrollPosition {
  scrollPosition: number;
  isAtTop: boolean;
}

export const useScrollPosition = (threshold = 5): ScrollPosition => {
  const [scrollPosition, setScrollPosition] = useState(document.body.scrollTop);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(document.body.scrollTop);
    };

    document.body.addEventListener('scroll', handleScroll);
    return () => {
      document.body.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return {
    scrollPosition,
    isAtTop: scrollPosition <= threshold
  };
};

export default useScrollPosition;
